import TncPage from "@/components/tnc/TncPage";
import {
  adivaaTncFooterNote,
  adivaaTncHero,
  adivaaTncSections,
} from "./tncContent";

export default function AdivaaAccidentalTnc() {
  return (
    <TncPage
      hero={adivaaTncHero}
      sections={adivaaTncSections}
      footerNote={adivaaTncFooterNote}
      path="/adivaa/accidental/tnc"
    />
  );
}
